export default {"src":"/_next/static/image/public/icons/arrow-big.36d887e1ae44152eca4a796f947426d7.svg","height":30,"width":30};